<template>
  <div class="operate">
    <page-list-container :total="total" :pageSize="pageSize" :inputCurrentPage="currentPage"
      @onPageChange="onPageChange" @onSizeChange="onSizeChange">
      <div>
        <operate-title-bar></operate-title-bar>
        <operate-cell v-for="(item, index) of dataArray" :key="index" :model="item" :index="index"
          :isSelected="selectedIndex === index" @onSelectClick="onCellSelectClick"></operate-cell>
      </div>
    </page-list-container>
  </div>
</template>

<script>
import PageListContainer from "@c/operation-log/common/paging-list/page-list-container.vue";
import OperateTitleBar from "@c/operation-log/pad-operate/pad-operate-title-bar.vue";
import OperateCell from "@c/operation-log/pad-operate/pad-operate-cell.vue";
import { DateTool } from "@js/date-tool.js";
export default {
  components: {
    PageListContainer,
    OperateTitleBar,
    OperateCell,
  },

  props: {
    duration: Object,
  },

  data() {
    return {
      // 搜索
      startTime: 0,
      endTime: 0,
      keyword: "",
      //列表
      dataArray: [],
      total: 0,
      pageSize: undefined,
      currentPage: 1,
      selectedModel: null,
      selectedIndex: null
    };
  },

  computed: {
    hospitalID() {
      return this.$store.state.selectedHospital.hospitalid;
    },
  },

  watch: {
    hospitalID() {
      this.currentPage = 1;
      this.getOperationLogList();
    },

    duration() {
      this.startTime = this.duration.startTime;
      this.endTime = this.duration.endTime;
      this.currentPage = 1;
      this.getOperationLogList();
    },
  },

  mounted() {
    this.pageSize = bestPageSizeComputer()
    this.getOperationLogList();
  },

  methods: {
    //分页
    onPageChange(currentPage) {
      this.currentPage = currentPage;
      this.getOperationLogList();
    },

    onSizeChange(size) {
      this.pageSize = size
      this.currentPage = 1
      this.getOperationLogList();
    },

    // action
    // 搜索
    onDurationSelected(startTime, endTime) {
      this.startTime = startTime;
      this.endTime = endTime;
      this.currentPage = 1;
      this.getOperationLogList();
    },

    onSearchClick(keyword) {
      this.keyword = keyword
      this.currentPage = 1;
      this.getOperationLogList();
    },

    //cell
    onCellSelectClick: function (index) {
      this.selectedModel = this.dataArray[index];
      this.selectedIndex = index;
    },

    //分页
    onPagination: function (currentPage) {
      this.currentPage = currentPage;
      this.getOperationLogList();
    },

    // method
    async getOperationLogList() {
      this.selectedIndex = null;
      this.selectedModel = null;
      try {
        const params = {
          "hospitalId": this.hospitalID == null ? null : this.hospitalID,
          "pageNum": this.currentPage,
          "pageSize": this.pageSize,
          "startTime": DateTool.timestampToStr(this.startTime, 'Y-M-D h:m:s'),
          "endTime": DateTool.timestampToStr(this.endTime, 'Y-M-D h:m:s'),
          "keyword": this.keyword,
        };
        const data = await this.$api.getPadLogList(params);
        this.dataArray = data.list;
        this.total = data.total;
      } catch (error) {
        this.$toast.showRed(error);
      }

    },
  },
};
</script>


<style lang="scss" scoped>
.operate {
  font-size: 19px;
  width: 100%;
}
</style>